import styled from "styled-components";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/section/footer/Footer";
import MenuSpacer from "../../components/spacer/MenuSpacer";
import FaqSection from "./components/FaqSection";

const Wrapper = styled.div``;

const FaqWrapper = styled.div`
  padding-top: 10px;

  @media (max-width: 950px) {
    padding: 10px 40px;
  }
`;

function FaqPage() {
  return (
    <Wrapper>
      <Navbar />
      <MenuSpacer />
      <FaqWrapper>
        <FaqSection type="shipping" />
        <FaqSection type="returns" />
        <FaqSection type="privacy" />
        <FaqSection type="careGuide" />
      </FaqWrapper>
      <Footer />
    </Wrapper>
  );
}

export default FaqPage;
